import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { MenuBar } from "../../components/Menu/Menu";
import { getCurrentMeeting } from "../../store/actions/meeting.action";
import { useTranslation } from "react-i18next";
import MeetingParticipantProfile from "../../components/users/MeetingParticipantProfile";

export default function Accept() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [menuOpen, setMenuOpen] = useState(false);
  const token = localStorage.getItem("token");
  const mail = localStorage.getItem("mail");
  const currentMeeting = useSelector((state) => state.meeting.currentMeeting);

  useEffect(() => {
    dispatch(getCurrentMeeting({ token, id }));
  }, [dispatch, token, mail, id]);

  const closeMenuBar = () => {
    setMenuOpen(false);
  };

  const openMenuBar = () => {
    setMenuOpen(true);
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1; // Months are zero-indexed
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    const formattedDate = `${day}/${month}/${year}`;
    const formattedTime = `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;

    return `${formattedDate} ${formattedTime}`;
  };

  return (
    <div className="max-w-screen-2xl mx-auto p-4 h-full">
      <Header openMenu={openMenuBar} />
      {/* {currentLearnerUser && currentMeeting && ( */}
      <>
        <div className="flex flex-col md:flex-row">
          <div className="basis-1/2 flex flex-col items-center justify-center">
            <div className="flex justify-center">
              <img
                src={
                  "https://res.cloudinary.com/do6t8sxgo/image/upload/v1724620572/Accept_o4mgxj.png"
                }
                alt="AcceptImage"
                className="w-[200px] h-[200px] md:w-[300px] md:h-[300px] xl:w-[400px] xl:h-[400px]"
              />
            </div>
            <p className="text-center text-xl md:text-2xl xl:text-3xl mb-20">
              {t("meeting.accepted")}
            </p>
          </div>
          <div className="basis-1/2">
            <MeetingParticipantProfile 
              meeting={currentMeeting} 
              t={t} 
              formatDateTime={formatDateTime}
              showMeetingDetails={true}
            />
          </div>
        </div>
      </>
      {/* )} */}
      <Footer />
      <MenuBar open={menuOpen} close={closeMenuBar} />
    </div>
  );
}
